import BaseService from '@/features/BaseService';

export default class ReportService extends BaseService {

  constructor() {
    super('reports');
  }

}



// WEBPACK FOOTER //
// ./src/features/report/ReportService.js